"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./pathwayMobileBottomSheet.scss");
const arrow_down_black_svg_1 = __importDefault(require("../../../assets/images/icons/arrow-down-black.svg"));
const arrow_up_black_svg_1 = __importDefault(require("../../../assets/images/icons/arrow-up-black.svg"));
const PathwayPrerequisites_1 = __importDefault(require("../pathwayPrerequisites/PathwayPrerequisites"));
function isSinglePathway(infoNode) {
    return "campaigns" in infoNode;
}
function PathwayMobileBottomSheet(props) {
    var _a, _b;
    const { infoNode } = props;
    const [showShareSheet, setShowShareSheet] = react_1.default.useState(true);
    const [isExpanded, setIsExpanded] = react_1.default.useState(false);
    const [isFooterVisible, setIsFooterVisible] = react_1.default.useState(true);
    const [isScrolling, setIsScrolling] = react_1.default.useState(false);
    const [activeIcon, setActiveIcon] = (0, react_1.useState)(arrow_up_black_svg_1.default);
    (0, react_1.useEffect)(() => {
        const handleTouchStart = () => {
            setIsScrolling(false);
        };
        const handleTouchMove = () => {
            setIsScrolling(true);
        };
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        return () => {
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (!isFooterVisible) {
                if (window.scrollY > 30) {
                    setShowShareSheet(true);
                }
                else {
                    setShowShareSheet(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        const footer = document.getElementById("hybrid-footer");
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setShowShareSheet(false);
                    setIsFooterVisible(true);
                }
                else {
                    setIsFooterVisible(false);
                    handleScroll();
                }
            });
        }, { threshold: [0] });
        if (footer) {
            observer.observe(footer);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (footer) {
                observer.unobserve(footer);
            }
        };
    }, [isFooterVisible]);
    return (react_1.default.createElement("div", { id: "pathway-mobile-bottom-sheet", style: {
            display: showShareSheet ? "flex" : "none",
        } }, isSinglePathway(infoNode) ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "pathway-title-row" },
            react_1.default.createElement("span", { className: "share-title" }, infoNode.title),
            react_1.default.createElement("img", { src: activeIcon, onClick: () => {
                    setActiveIcon(activeIcon === arrow_up_black_svg_1.default ? arrow_down_black_svg_1.default : arrow_up_black_svg_1.default);
                    setIsExpanded(!isExpanded);
                }, alt: "Open Dropdown", height: 17 })),
        isExpanded && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: `description-row ${isExpanded ? "expanded" : "collapsed"}` },
                react_1.default.createElement("span", { className: "pathway-description" }, infoNode.description)))))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "pathway-title-row" },
            react_1.default.createElement("span", { className: "share-title" }, (_a = infoNode.campaign) === null || _a === void 0 ? void 0 : _a.title),
            react_1.default.createElement("img", { src: activeIcon, onClick: () => {
                    setActiveIcon(activeIcon === arrow_up_black_svg_1.default ? arrow_down_black_svg_1.default : arrow_up_black_svg_1.default);
                    setIsExpanded(!isExpanded);
                }, alt: "Open Dropdown", height: 17 })),
        isExpanded && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: `description-row ${isExpanded ? "expanded" : "collapsed"}` },
                react_1.default.createElement("span", { className: "pathway-description" }, (_b = infoNode.campaign) === null || _b === void 0 ? void 0 : _b.description)),
            infoNode.automationRules && (react_1.default.createElement("div", { style: { marginTop: "20px" } },
                react_1.default.createElement(PathwayPrerequisites_1.default, { automationRules: infoNode.automationRules })))))))));
}
exports.default = PathwayMobileBottomSheet;
